export * from './TickLabel';
